<div class="details-grid">
  <!-- Labels Section -->
  @if (!isTestStepSelected || !isDoView) { @if (localNodeField || univeralNodeField) {
  <div class="detail-row">
    <div class="detail-label">
      <span>Labels</span>
    </div>
    <div class="detail-value">
      <p-autoComplete
        #mergedLabelsAuto
        [multiple]="true"
        [forceSelection]="true"
        [dropdown]="true"
        display="chip"
        name="targetMapMergedSelect"
        [suggestions]="filteredTargetMapsMerged"
        (completeMethod)="filterTargetMapsMerged.emit($event)"
        field="name"
        [(ngModel)]="targetMapsMergedSelected"
        (onSelect)="targetMapMergedSelect.emit($event.value)"
        (onUnselect)="targetMapMergedUnselect.emit($event.value)"
        (onClear)="targetMapsMergedClear.emit()"
        [placeholder]="(targetMapsMergedSelected?.length ?? 0) === 0 ? 'None' : ''"
        [emptyMessage]="'No maps found'"
        (click)="openAutocompleteDropdown(mergedLabelsAuto)"
        (onFocus)="openAutocompleteDropdown(mergedLabelsAuto)">
        <ng-template let-item pTemplate="item">
          <div class="target-map-option" [attr.title]="buildLabelTooltip(item)">
            <div>{{ getDisplayLabel(item) }}</div>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="selectedItem">
          <span class="target-chip" [attr.title]="buildLabelTooltip(item)">{{ getDisplayLabel(item) }}</span>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>
  } }

  <!-- Main Fields -->
  @for (field of detailFieldList; track field.id; let i = $index) { @if ((field?.name?.toLowerCase() !== epicNameFieldName || showEpicNameField) && (field?.name?.toLowerCase() !==
  extAppReferenceFieldName || isExternalIntegrationProject) && !field?.name?.toLowerCase().includes('apply as universal node') && !field?.name?.toLowerCase().includes('apply as local node')) {
  <div class="detail-row" [class.readonly]="field?.value?.isReadOnly">
    <div class="detail-label" [matTooltip]="getFieldTooltip(field)">{{ getFieldDisplayLabel(field) }}</div>
    <div class="detail-value">
      <app-dynamic-field-input
        [field]="field"
        [value]="formData[field.id]"
        [index]="i"
        [projectId]="projectId" [workspaceId]="workspaceId" [nodeInstanceId]="nodeInstanceId" [nodeKey]="nodeKey"
        [buildDropdownOptions]="buildDropdownOptions"
        [buildUserDropdownOptions]="buildUserDropdownOptions"
        (valueChange)="onFieldValueChange($event, field.id, field.name)"
        (assigneeChange)="assigneeChange.emit($event)"
        (dateChange)="calendarDateChange.emit($event)"
        (dateClear)="calendarDateClear.emit($event)"
        (dateSet)="calendarDateSet.emit()">
      </app-dynamic-field-input>
    </div>
  </div>
  } }

  <!-- Bug Fields -->
  @if ((bugFieldList?.length ?? 0) > 0) { @for (bugField of bugFieldList; track bugField) {
  <div class="detail-row">
    <div class="detail-label" [matTooltip]="getFieldTooltip(bugField)">{{ getFieldDisplayLabel(bugField) }}</div>
    <div class="detail-value">
      <app-dynamic-field-input
        [field]="bugField"
        [value]="formData[bugField.id]"
        [projectId]="projectId" [workspaceId]="workspaceId" [nodeInstanceId]="nodeInstanceId" [nodeKey]="nodeKey"
        [buildDropdownOptions]="buildDropdownOptions"
        [buildUserDropdownOptions]="buildUserDropdownOptions"
        (valueChange)="onFieldValueChange($event, bugField.id, bugField.name)"
        (assigneeChange)="assigneeChange.emit($event)">
      </app-dynamic-field-input>
    </div>
  </div>
  } }

  <!-- Test Step Details -->
  @if (isTestStepSelected && isDoView) { @for (testInputField of testInputFieldList; track testInputField) {
  <div class="detail-row stacked" [style.pointer-events]="stepFieldsReadOnly ? 'none' : null" [style.opacity]="stepFieldsReadOnly ? 0.7 : null">
    <div class="detail-label">
      <span>{{ testInputField.fieldName | lodashWrapper: 'startCase' }}</span>
    </div>
    <div class="detail-value">
      <!-- One block for every step field. The ref is on all of them and the description is
           picked out by index in focusTestStepDetails — a plain @ViewChild would bind to
           whichever field happens to render first, which is not necessarily the description. -->
      <app-rich-text-field
        #stepFieldEditor
        [value]="testInputField.value"
        [placeholder]="testInputField.fieldName | lodashWrapper: 'startCase'"
        [projectId]="projectId" [workspaceId]="workspaceId" [nodeInstanceId]="nodeInstanceId"
        [attachmentDialogContext]="'test-step'" [attachmentDialogData]="selectedTestStep"
        [imageNamePrefix]="stepFieldImageNamePrefix"
        (valueChange)="testInputField.value = $event"
        (blur)="stepFieldInputChange.emit({ value: $event, fieldName: testInputField.fieldName })"
        (imageAttached)="stepFieldImageAttached.emit($event)">
      </app-rich-text-field>
    </div>
  </div>
  } }
</div>
